// Configuración central y constantes del juego.
// Mantener aquí los valores compartidos evita "números mágicos" dispersos por las escenas.

export const GAME = { WIDTH: 1280, HEIGHT: 720 };

// Paleta cósmica-neón original (identidad visual "Techno Math").
export const HEX = {
  bgDeep: 0x0a0620,
  cyan: 0x38f0e0,
  magenta: 0xff4dd8,
  violet: 0x7c4dff,
  gold: 0xffd23f,
  green: 0x4dff9e,
  red: 0xff5470,
  white: 0xffffff,
  slate: 0x1a1440,
};

export const CSS = {
  bgDeep: '#0a0620',
  cyan: '#38f0e0',
  magenta: '#ff4dd8',
  violet: '#7c4dff',
  gold: '#ffd23f',
  green: '#4dff9e',
  red: '#ff5470',
  white: '#ffffff',
  dim: '#b9a9ff',
};


// Identidad única de las gemas que aparecen detrás de las respuestas.
// No se usa para las gemas de vida del HUD: esas permanecen rojas.
export const ANSWER_GEM_THEMES = Object.freeze({
  suma: { tint: 0x38f0e0, scale: 1.25 },
  resta: { tint: 0xff5fcf, scale: 1.25 },
  // Dorado cálido con borde ámbar oscuro: se separa del bosque sin usar verde como identidad.
  multiplicacion: {
    tint: 0xffc947,
    scale: 1.25,
    outlineTint: 0x3b2106,
    outlineScale: 1.11,
    outlineAlpha: 0.82,
  },
  // Aqua luminoso: conserva la identidad oceánica y se separa del fondo submarino.
  division: { tint: 0x72fff6, scale: 1.25, outlineTint: 0x082b59, outlineScale: 1.12, outlineAlpha: 0.86 },
});

export const getAnswerGemTheme = (world) => {
  const key = world === 'mult' ? 'multiplicacion' : world;
  return ANSWER_GEM_THEMES[key] || ANSWER_GEM_THEMES.suma;
};

// Color de identidad compartido por elementos de HUD durante el gameplay.
// Estados universales (vidas, error y correcto) permanecen fuera de este mapa.
export const GAMEPLAY_UI_THEMES = Object.freeze({
  suma: { tint: 0x38f0e0 },
  resta: { tint: 0xff5fcf },
  multiplicacion: { tint: 0xffd23f },
  division: { tint: 0x72fff6 },
});

export const getGameplayUiTheme = (world) => {
  const key = world === 'mult' ? 'multiplicacion' : world;
  return GAMEPLAY_UI_THEMES[key] || GAMEPLAY_UI_THEMES.suma;
};

export const FONTS = {
  display: "'Orbitron', sans-serif",
  friendly: "'Baloo 2', sans-serif",
};

// Física pensada para niños: brincos amplios, control aéreo total, colisiones tolerantes.
export const PHYS = {
  GRAVITY: 1400,
  MOVE: 420,
  JUMP: 780,
  JUMP_CUT: 0.45,
  COYOTE_MS: 130,
  BUFFER_MS: 140,
};

export const LEVEL = {
  PLAT_TOP: 560,
  PLAT_H: 60,
  CHALLENGES: 6,
  START_TIME: 90,
  MAX_LIVES: 3,
  BASE_POINTS: 100,
  BONUS_CRYSTAL: 25,
  TIME_CORRECT: 5,
  TIME_WRONG: 8,
  PERFECT_SPEED_BONUS_MAX: 500,
};

// Punto único donde se conectará el backend en el futuro (rankings, nube, multijugador).
export const API_BASE = process.env.REACT_APP_BACKEND_URL || '';
